/* src/app/features/honra/validacao-scr/validacao-scr-listagem.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=validacao-scr-listagem.component.css.map */
